
import { getThirtyDaysAgo } from './dateUtils';

/**
 * Filter array by date
 */
export function filterByDate(
  items: any[], 
  dateField: string, 
  startDate: Date, 
  endDate: Date = new Date()
): any[] {
  return items.filter(item => {
    try {
      const itemDate = new Date(item[dateField]);
      return itemDate >= startDate && itemDate <= endDate;
    } catch (e) {
      console.error(`Invalid date in item: ${JSON.stringify(item)}`);
      return false;
    }
  });
}

/**
 * Get recent items from the last 30 days
 */
export function getRecentItems(items: any[], dateField: string): any[] {
  const thirtyDaysAgo = getThirtyDaysAgo();
  return filterByDate(items, dateField, thirtyDaysAgo);
}

/**
 * Filter CVEs by severity score range or severity text
 */
export function filterCVEsBySeverity(
  cves: any[],
  minScore: number,
  maxScore: number,
  severityTextEn: string,
  severityTextPl: string
): any[] {
  return cves.filter(cve => {
    // Check if the item has a numeric score within range
    if (typeof cve.score === 'number') {
      return cve.score >= minScore && cve.score < maxScore;
    }
    
    // Check if the item has a string score that can be parsed
    if (typeof cve.score === 'string' && !isNaN(parseFloat(cve.score))) {
      const numericScore = parseFloat(cve.score);
      return numericScore >= minScore && numericScore < maxScore;
    }
    
    // If no numeric score, check for text-based severity in either language
    const severityEn = cve.severity_en?.toLowerCase() || '';
    const severityPl = cve.severity?.toLowerCase() || '';
    
    return severityEn === severityTextEn.toLowerCase() || severityPl === severityTextPl.toLowerCase();
  });
}
